import React from 'react';
import {
  StyledTabs,
  StyledTab,
  StyledTabsRes,
} from 'components/DashTabs/styles';
import { IntlShape, injectIntl } from 'react-intl';
import { pushTo } from 'helpers/routes';
import { get } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function a11yProps(index?: number) {
  return {
    id: `navbar-tab-${index}`,
    'aria-controls': `navbar-tabpanel-${index}`,
  };
}
const DashTabs = ({
  items,
  setSelectedTab,
  handleCloseMenuSettings,
  ...otherProps
}: {
  items: { label: string; path: string }[];
  setSelectedTab: Function;
  handleCloseMenuSettings?: Function;
  intl: IntlShape;
}) => {
  const [value, setValue] = React.useState(0);
  /* istanbul ignore next */
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: number,
  ) => {
    setValue(newValue);
    setSelectedTab(get(items, newValue).label);
    pushTo(get(items, newValue).path);
  };
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const ResponsiveStyledTabs = matches ? StyledTabsRes : StyledTabs;
  return (
    <>
      <ResponsiveStyledTabs
        value={value}
        onChange={handleChange}
        aria-label="privelge tabs"
        onClick={handleCloseMenuSettings}
      >
        {items.length > 0 &&
          items.map((tab: any, index) => (
            <StyledTab key={index} label={tab.label} {...a11yProps(index)} />
          ))}
      </ResponsiveStyledTabs>
    </>
  );
};

export default injectIntl(DashTabs);
